import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
//import { Observable, Subject } from 'rxjs';
import { UserInfoService } from './user-info.service';

@Injectable({
  providedIn: 'root'
})
export class CatalogService {
  //private subject = new Subject<any>();
  constructor(private http: HttpClient, private _userService: UserInfoService) {
    //this.login();
  }

  assignStore(file: File, retailCompanyId : number, stores: any) {
    const formdata: FormData = new FormData();
    formdata.append('file', file);
    //let url = 'http://vendor-catalog-service/catalogs'
    const url = '/api/catalogs?retailerId='+retailCompanyId+'&storeIds=' + stores;
    // return this.http.post(url, formdata, { headers });
//console.log("assignStore");
    return this.http.post(url, formdata);
  }

  // success(message: string) {
  //   this.subject.next({ type: 'success', text: message });
  // }

  // error(message: string) {
  //   this.subject.next({ type: 'error', text: message });
  // }

  // getMessage(): Observable<any> {
  //   return this.subject.asObservable();
  // }

}

